import type { OrgType } from './persona'

export type HuntSchedulingOrg = {
  orgType: OrgType | null | undefined
  clubFeaturesActive?: boolean
}

export function canAddHuntInOrg(org: HuntSchedulingOrg): boolean {
  return org.clubFeaturesActive ?? org.orgType !== 'outfitter'
}
